import * as Sentry from "@sentry/browser";
import { TokenList } from "../store/global/getAllTokenLists";
import { Token, TOKEN_NAMES } from "../store/global/TokenEnum";
import { Amount } from "../types/amount";

export const transformPricesToBalances = (tokenList: TokenList) => {
  return Object.keys(tokenList).map(token => {
    return {
      symbol: token as Token,
      balance: Amount.ZERO,
    };
  });
};
export const getPriceForTokenByTokenList = (token?: Token, tokenList?: TokenList) => {
  if (tokenList && token) {
    const tokenEntry = tokenList[token];
    if (tokenEntry) {
      return tokenEntry.priceUsd;
    }
  }
  return Amount.ZERO;
};

export const getNameForToken = (token: Token, tokenList?: TokenList): string => {
  if (tokenList) {
    const name = tokenList[token]?.name;
    if (name) {
      return name;
    } else {
      Sentry.captureException(`Could not find a name from metadata for ${token}`);
    }
  }
  Sentry.captureException(`No metadata available. Returning hardcoded name for ${token}`);
  return TOKEN_NAMES[token] ?? "";
};
export const getColourForToken = (token: Token, tokenList?: TokenList): string | undefined => {
  if (tokenList) {
    const colour = tokenList[token]?.colour;
    if (colour) {
      return colour;
    } else {
      Sentry.captureException(`Could not find a colour from metadata for ${token}`);
    }
  }
};
